import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";

import { addBusinessDays } from "../../tables/WorkOrderRoutingTableV2/moveHelper";
import { generateItems } from "./helper";
import { StyledDisabledDatePicker } from "./styles";

const AddWorkOrderEndDate = ({ totalDays }) => {
  const { watch, setValue } = useFormContext();

  const isRepeat = watch("isRepeat");
  const repeatStartDate = watch("repeatStartDate");
  const batches = watch("batches");
  const repeatOption = watch("repeatOption");
  const repeatWeekdays = watch("repeatWeekdays");
  const repeatEvery = watch("repeatEvery");
  const repeatEveryIteration = watch("repeatEveryIteration");

  useEffect(() => {
    if (!isRepeat) {
      const startDate = repeatStartDate || dayjs().utc().toISOString();
      const dueDate = addBusinessDays(startDate, totalDays * 1440);
      setValue("dueDate", dueDate || null);
      return;
    }

    const isCustom = repeatOption === 4;
    const noWeekdays = !repeatWeekdays?.length;

    if (isCustom && noWeekdays) return;
    if (!batches) return;

    const itemspy = {
      batches,
      repeatStartDate,
      repeatOption,
      repeatWeekdays,
      repeatEvery,
      repeatEveryIteration,
      isRepeat,
    };
    const endDate = generateItems(itemspy, totalDays);
    setValue("dueDate", endDate?.dueDate || null);
  }, [
    isRepeat,
    repeatStartDate,
    batches,
    repeatOption,
    repeatWeekdays,
    repeatEvery,
    repeatEveryIteration,
    totalDays,
  ]);

  return (
    <StyledDisabledDatePicker
      name="dueDate"
      label="Projected End Date"
      disabled
    />
  );
};

export default AddWorkOrderEndDate;
